import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import { videos } from 'src/constants/videos'
import { useIsFuboSportsAvailable } from 'src/modules/hooks/useIsFuboSportsAvailable'
import { getFuboSportsCBBPlans } from 'src/constants/planData/fuboSportsCBBPlans'

export default (props) => {
  const { isAvailable } = useIsFuboSportsAvailable()

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={videos.cbb.videoUrl}
      staticAnnotation={videos.cbb.staticAnnotation}
      title="Watch college basketball live"
      subtitle="See top teams from around the country. Regional restrictions apply."
      networkSet="basketball"
      league="ncaa"
      showRSN={true}
      matchtickerSportId="59"
      matchtickerLeagueName="NCAA"
      matchtickerLeagueId="191260"
      sportId={sportIds.Basketball}
      leagueId={leagueIds["Men's NCAA Basketball"]}
      hasPlanCards={isAvailable}
      plans={isAvailable ? getFuboSportsCBBPlans() : []}
    />
  )
}
